export function getCurrentProgressState(state, patientId, encounterId, activeGenerations) {
  if (!patientId || !encounterId) return { isProgressReady: false };
  const currentGeneration = activeGenerations?.find(
    (g) => g.patientId === patientId && g.encounterId === encounterId
  );
  const key = currentGeneration
    ? `${currentGeneration.patientId}-${currentGeneration.encounterId}`
    : `${patientId}-${encounterId}`;
  const progressState = state?.recognizer?.progressState?.[key] || {};
  return {
    ...progressState,
    isProgressReady: progressState.isProgressReady ?? false,
  };
}